import { ForceUpdateService } from '@mathflat/shared/@modules/forceUpdate/forceUpdateService'
import { markPendingToast } from '@mathflat/shared/@modules/forceUpdate/postUpdateToast'
import { createLatestReleaseIdFetcher } from '@mathflat/shared/@modules/forceUpdate/releaseCheck'

import { envUtils } from '~/@common/utils/envUtils'

export const forceUpdateService = new ForceUpdateService({
  getMyReleaseId: () => envUtils.releaseId,
  getLatestReleaseId: createLatestReleaseIdFetcher({
    isDebugOverrideAllowed: () => !envUtils.isLive,
  }),
  navigate: (destinationUrl) => window.location.assign(destinationUrl),
  onBeforeReload: markPendingToast,
})
